<section class="edp-terms-conditions-modal justify-content-center">
    <div class="align-items-center justify-content-center flex-column" [ngClass]="{ 'd-none': showTerms, 'd-flex': !showTerms }">
        <i class="icon mb-4 icon-edponline-Bop-138" aria-hidden="true"></i>
        <h1 class="title mb-4">
            {{ "pt.edponline.terms.modal.title" | translate }}
        </h1>

        <form [formGroup]="form" class="edp-form w-100" (ngSubmit)="submit()">
            <div class="form-group mb-2">
                <label class="form-check-label pl-5 text-left">
                    <input class="form-check-input" type="checkbox" id="acceptTerms" formControlName="acceptTerms" />
                    <span class="form-check-mark"></span>
                </label>
                <div class="text-label pl-5">
                    <span>{{ "pt.edponline.terms.modal.check.label.prefix" | translate }}</span>
                    <a class="edp-text-seaweed-green cursor-pointer" target="_blank" href="{{ 'pt.edponline.terms.modal.privacy.link' | translate }}">
                        {{ "pt.edponline.terms.modal.check.label.link" | translate }}
                    </a>
                    <span>{{ "pt.edponline.terms.modal.check.label.sufix" | translate }}</span>
                </div>
            </div>
            <p class="description mb-5">
                <span>{{ "pt.edponline.terms.modal.description.label.prefix" | translate }}</span>
                <a class="edp-text-seaweed-green cursor-pointer" [href]="'mailto:' + mailTo">{{ mailTo }}</a>
                <span>{{ "pt.edponline.terms.modal.description.label.sufix" | translate }}</span>
                <a class="edp-text-seaweed-green cursor-pointer" target="_blank" href="{{ 'pt.edponline.terms.modal.privacy.link' | translate }}">
                    {{ "pt.edponline.terms.modal.description.label.link" | translate }}
                </a>
            </p>

            <button type="submit" class="btn btn-primary w-100" [disabled]="form.invalid">
                {{ "pt.edponline.terms.modal.button.submit" | translate }}
            </button>
        </form>
    </div>

    <ng-container *ngIf="showTerms">
        <ng-container *ngTemplateOutlet="termsTamplate"></ng-container>
    </ng-container>
</section>

<ng-template #termsTamplate>
    <div class="d-flex flex-column h-100">
        <i class="btn-close icon-edponline-Bop-071" (click)="closeTerms()" aria-hidden="true"></i>
        <h1 class="title mb-4">
            {{ "pt.edponline.terms.detail.title" | translate }}
        </h1>

        <p class="text-terms" [innerHTML]="'pt.edponline.terms.detail.terms' | translate"></p>
        <button type="button" class="btn edp-secondary-btn edp-large-button align-self-end" (click)="closeTerms()">
            {{ "pt.edponline.terms.modal.button.close" | translate }}
        </button>
    </div>
</ng-template>
